/* eslint-disable react/prop-types */
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from "@chakra-ui/react";
import React, { Suspense, useEffect, useState } from "react";
import isTableauAvailable from "../../utils/isTableauAvailable";
import StaticImage from "../ReportsComponents/StaticImage/StaticImage";
import DirectoryCards from "../SampleDataPage/DirectoryCards";

const PowerBi = React.lazy(
  () => import("../ReportsComponents/PowerBI/PowerBi"),
);
const TableauEmbed = React.lazy(
  () => import("../ReportsComponents/Tableau/TableauEmbed"),
);
const TableauNotAvailableThisTime = React.lazy(
  () => import("../ReportsComponents/Tableau/TableauNotAvailableThisTime"),
);

const DataCardModal = ({ isOpen, onClose, data }) => {
  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    if (isTableauAvailable()) {
      setIsAvailable(true);
    }
  }, []);

  const renderComponentByType = (type, data) => {
    switch (type) {
      case "tableau":
        return isAvailable ? (
          <TableauEmbed embedData={data} />
        ) : (
          <TableauNotAvailableThisTime />
        );
      case "powerbi":
        return <PowerBi powerBiData={data} />;
      case "directory":
      case "file":
        return <DirectoryCards data={data} />;
      default:
        return <StaticImage imageData={data} />;
    }
  };

  return (
    <Modal
      blockScrollOnMount
      motionPreset="slideInBottom"
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: "sm", md: "4xl", lg: "6xl" }}
      isCentered
      closeOnOverlayClick={false}
      closeOnEsc
    >
      <ModalOverlay />
      <ModalContent h="91vh" width="100%" p={0}>
        <ModalCloseButton right={0} top={0} color="red" zIndex={10000} />
        <ModalBody p={1} overflow="hidden" h="100%">
          <Box w="100%" h="100%">
            <Suspense fallback={<Box p={5}>Loading visualization...</Box>}>
              {renderComponentByType(data.type, data)}
            </Suspense>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DataCardModal;
